// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"a71a2403","804":"d3e40000"}[chunkId] + ".chunk.js";
};